module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isEditValid),
      callback: function($$v) {
        _vm.isEditValid = $$v
      },
      expression: "isEditValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Active"
    },
    model: {
      value: (_vm.objRoleEdit.active),
      callback: function($$v) {
        _vm.$set(_vm.objRoleEdit, "active", $$v)
      },
      expression: "objRoleEdit.active"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Role Name:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Name",
      "rules": _vm.nameRules,
      "required": "",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.objRoleEdit.name),
      callback: function($$v) {
        _vm.$set(_vm.objRoleEdit, "name", $$v)
      },
      expression: "objRoleEdit.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Role Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Description",
      "rules": _vm.descriptionRules,
      "required": "",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.objRoleEdit.description),
      callback: function($$v) {
        _vm.$set(_vm.objRoleEdit, "description", $$v)
      },
      expression: "objRoleEdit.description"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Role User Type:")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.userType,
      "label": "User Type",
      "rules": _vm.userRules,
      "required": "",
      "item-value": "id",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.objRoleEdit.user_type),
      callback: function($$v) {
        _vm.$set(_vm.objRoleEdit, "user_type", $$v)
      },
      expression: "objRoleEdit.user_type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.objRoleEdit.user_type == '1'),
      expression: "objRoleEdit.user_type == '1'"
    }],
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Is Role Commercial Role:")]), _vm._v(" "), _c('v-switch', {
    model: {
      value: (_vm.objRoleEdit.is_commercial_kam),
      callback: function($$v) {
        _vm.$set(_vm.objRoleEdit, "is_commercial_kam", $$v)
      },
      expression: "objRoleEdit.is_commercial_kam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-4 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.runAdd) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.isEditValid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncEditRole()
      }
    }
  }, [_vm._v("Update")]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}